/**
 * @param {String} selector
 * @param {*} opts
 */
export function NewsletterForm(selector, opts = {}) {
  const defaults = {
    successSelector: '[data-newsletter-success]',
  };

  const element = document.querySelector(selector);

  if (!element) {
    return {};
  }

  const options = {
    ...defaults,
    ...opts,
    ...element.dataset,
  };

  const successElement = element.querySelector(options.successSelector);

  bindEventListeners();

  function bindEventListeners() {
    window.addEventListener('load', handleLoad);
  }

  function handleLoad() {
    if (!successElement) {
      return;
    }

    scrollTo();
  }
  
  function scrollTo() {
    element.scrollIntoView();
  }

  function destroy() {
    window.removeEventListener('load', handleLoad);
  }
}
